import { render } from "./CompanyRegisterView.vue?vue&type=template&id=440c6e3c"
import script from "./CompanyRegisterView.vue?vue&type=script&lang=js"
export * from "./CompanyRegisterView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__